const OperadoresHome = () => import(/* webpackChunkName: "group-callcenter-cadastros" */ '../_views/OperadoresHome')
const CadastroOperador = () => import(/* webpackChunkName: "group-callcenter-cadastros" */ '../_views/CadastroOperador')
const AtualizarOperador = () =>
  import(/* webpackChunkName: "group-callcenter-cadastros" */ '../_views/AtualizarOperador')

import { permissionsCadastroOperador } from '../../../../../utils/permissionsCallCenter'

export default [
  {
    path: 'operador',
    meta: { requiresAuth: true, permissions: [...permissionsCadastroOperador] },
    component: OperadoresHome,
    name: 'Operador',
  },
  {
    path: 'operador/criar',
    meta: {
      requiresAuth: true,
      permissions: [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_CALLCENTER_CADASTRO_OPERADOR_TOTAL],
    },
    component: CadastroOperador,
    name: 'Operador/criar',
  },
  {
    path: 'operador/atualizar/:_id',
    meta: { requiresAuth: true, permissions: [...permissionsCadastroOperador] },
    component: AtualizarOperador,
    name: 'Operador/atualizar',
    props: true,
  },
]
